<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2 margin-bottom-20">{{ $t('views.payout_detail.title') }}</h1>
            <table class="table" v-if="payout_detail">
                <tbody>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('components.payout.amount') }}</b></td>
                    <td>{{getCurrencySymbolFromString(payout_detail.currency)}}{{(payout_detail.amount/100).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('components.payout.fee') }}</b></td>
                    <td>{{getCurrencySymbolFromString(payout_detail.currency)}}{{((payout_detail.amount/100).toFixed(2) - (payout_detail.amount_net/100).toFixed(2)).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('components.payout.net') }}</b></td>
                    <td>{{getCurrencySymbolFromString(payout_detail.currency)}}{{(payout_detail.amount_net/100).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('components.payout.created_date') }}</b></td>
                    <td>{{getDataString(payout_detail.created * 1000)}}</td>
                </tr>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('components.payout.arrival_date') }}</b></td>
                    <td>{{getShortDataString(payout_detail.arrival_date * 1000)}}</td>
                </tr>
                <tr>
                    <td style="text-align: left; width: 30%"><b>{{ $t('common.state') }}</b></td>
                    <td><span :class="getClassLabelStatusPayout(payout_detail.status)" class="label">{{getStringStatusPayout(payout_detail.status)}}</span></td>
                </tr>
                </tbody>
            </table>
            <h4>{{ $t('views.payout_detail.transactions') }}</h4>
            <div class="table-responsive" v-if="payoutTransactions.length > 0">
                <PayoutTransactionsTable :payout-transactions="payoutTransactions"></PayoutTransactionsTable>
            </div>
            <div v-else>
                <span class="text-muted">{{ $t('views.payout_detail.transactions_not_found') }}</span>
            </div>
            <div class="text-center" v-if="has_more">
                <a href="" @click.prevent.stop="showMoreCallback" class="btn btn-primary"><i class="las la-download"></i> {{ $t('common.show_more') }}</a>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import {getPayoutDetail, getPayoutTransactions} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import i18n from '../i18n'
    import PayoutTransactionsTable from "../components/payout/PayoutTransactionsTable";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import {Utils} from "../common/utils";

    export default {
        title: i18n.t('views.payout_detail.title'),
        name: "Payouts",
        components: { ContainerWithMenu, SpinnerLoader, PayoutTransactionsTable},
        data: () => {
            return {
                payoutTransactions: [],
                payout_detail: {},
                limitPayouts: LIMIT_RECORDS_API,
                loading: false,
                has_more: false
            }
        },
        methods: {
            getDataString(date) {
                return Utils.getDateStringFromISO(date)
            },
            getShortDataString(date) {
                return Utils.getShortDateStringFromISO(date)
            },
            getStringStatusPayout(state) {
                return Utils.getStringStatusPayout(state)
            },
            getClassLabelStatusPayout(payout_state) {
                return Utils.getClassLabelStatusPayout(payout_state)
            },
            async getPayoutTransactions(starting_after=null) {
                this.loading = true;
                try {
                    let payoutTransactionsResponse = await getPayoutTransactions(this.$route.params.payout_id, this.limitPayouts, starting_after);
                    this.payoutTransactions = this.payoutTransactions.concat(payoutTransactionsResponse.data);
                    this.has_more = payoutTransactionsResponse.has_more;
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async getPayoutDetail() {
                this.loading = true;
                try {
                    this.payout_detail = await getPayoutDetail(this.$route.params.payout_id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showMoreCallback() {
                this.getPayoutTransactions(this.payoutTransactions[this.payoutTransactions.length-1].id)
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        },
        mounted() {
            this.getPayoutDetail();
            this.getPayoutTransactions();
        }
    };
</script>